<div  role="document">
    <div class="modal-content">
      <div class="modal-body" id="contentToConvert" *ngIf="invoice">
        <div class="row">
          <div class="invoice-header">
            <div class="logo">
              <img src="../../../assets/logo.png">
            </div>
            <div class="company-details">
              <p class="small-text">3 Bolt Court | Fleet Street | London | EC4A 3DQ</p>
              <p class="small-text">T : 020 3745 3150 | M : 07783 904 770 F : 020 3137 5001 E : clerks@3boltcourt.com W: www.3boltcourt.com</p>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-12">
            <h4>Professional Fees of : </h4>
            <h4>{{invoice.barristerName}}</h4>
          </div>
        </div>
        <div class="row mt-2">
          <table class="table">
            <tr width="100%">
              <td width="50%">
                <div class="full-border" *ngIf="invoice.solicitor">
                  <p>{{invoice.solicitor.solicitorName}}</p>
                  <p>{{invoice.solicitor.companyName}}</p>
                  <p>{{invoice.solicitor.address}}</p>
                  <p>{{invoice.solicitor.address1}} {{invoice.solicitor.city}} </p>
                  <p>{{invoice.solicitor.postcode}}</p>
                </div>
                <div class="full-border" *ngIf="invoice.client">
                  <p>{{invoice.client.clientName}}</p>
                  <p>{{invoice.client.clientAddress}}</p>
                  <p>{{invoice.client.clientPostcode}}</p>
                </div>
              </td>
              <td width="50%">
                <p>Vat No : {{invoice.vatNo}}</p>
                <p>Legal Aid Number : {{invoice.legalAidNumber}}</p>

              </td>
            </tr>
          </table>
        </div>
        <div class="row">
          <div class="col-md-12 mb-2">
            <p class="small-text "> <strong>Our Reference : </strong> {{invoice.invoiceRef}}</p>
          </div>
        </div>
        <div class="row mt-2">
          
          <p class="small-text" *ngIf="invoice.solicitor"> <strong>Solicitor's Reference : </strong> {{invoice.solicitorRef}}</p><br />
          <div class="full-border">
            <h4> {{invoice.claimant}} - and - {{invoice.defendant}} </h4>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-12">
            <table class="table">
              <tr>
                <td colspan="2"><span class="small-text">Court</span> : {{invoice.courtName}}</td>
              </tr>
              <tr>
                <td><span class="small-text">Court Ref No</span> : {{invoice.courtRef}}</td>
                <td><span class="small-text">Date : </span> 
                  {{invoice.courtDate | date : 'dd-MM-yyyy'}}
                </td>
              </tr>
              <tr>
                <td><span class="small-text">Case Type</span> : {{invoice.caseTypeName}}</td>
                <td><span class="small-text">Funding Type : </span> {{invoice.fundingTypeName}}</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="row mt-2 mb-4">
          <table class="table info">
            <thead>
                <td width="30%">Date</td>
                <td width="40%">Description</td>
                <td width="10%">Amount</td>
                <td width="10%">Vat</td>
                <td width="10%">Total</td>
            </thead>
            <tbody>
              <tr *ngFor="let item of invoice.payments">
                <td>
                  <span *ngIf="item.endDate != item.courtDate && item.invoiceType == 'charge'">{{item.courtDate | date : 'dd-MM-yyyy'}} to </span>
                  {{item.dueDate | date : 'dd-MM-yyyy'}}
                </td>
                <td>{{item.details}} <span *ngIf="item.invoiceType != 'charge'" class="badge badge-danger mt-2" (click)="deletePayment(item.id)"  style="cursor: pointer;"> Delete Transaction </span></td>
                <td> <span *ngIf="item.invoiceType != 'charge' && item.amount > 0"> - </span> {{ item.amount | currency : 'GBP'}}</td>
                <td> <span *ngIf="item.invoiceType != 'charge' && item.vat > 0"> - </span> {{ item.vat | currency : 'GBP'}}</td>
                <td>
                  <span *ngIf="item.invoiceType != 'charge' && item.total > 0"> - </span> {{ item.total | currency : 'GBP'}}
                  
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td></td>
                <td>Total Outstanding</td>
                <td>{{invoice.balance.totalAmount | currency : 'GBP'}}</td>
                <td>{{invoice.balance.totalVat | currency : 'GBP'}}</td>
                <td>{{invoice.balance.totalDue | currency : 'GBP'}}</td>
              </tr>
            </tfoot>
          </table>
        </div>
        
      </div>
      <div class="modal-footer">
        
          <form #paymentForm="ngForm">
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label for="paymentDate">Payment Date</label>
                  <input type="date" name="paymentDate" id="paymentDate" class="form-control" placeholder="Payment Date" ngModel>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="details">Details</label>
                  <input  name="details" id="details" class="form-control" placeholder="Details" ngModel>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="amount">Amount</label>
                  <input  name="amount" id="amount" class="form-control" placeholder="Amount" ngModel>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="paymentMethod">Payment Method</label>
                  <select name="paymentMethod" id="paymentMethod" ngModel class="form-control">
                    <option value="Bank Transfer">Bank Transfer</option>
                    <option value="Cash">Cash</option>
                    <option value="Cheque">Cheque</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <button type="button" class="btn btn-primary mt-4" (click)="savePayment(paymentForm)" [disabled]="paymentForm.invalid">Save</button>
                </div>
              </div>
            </div>
            <div class="row mb-4" *ngIf="data.tableName != 'barrister'">
              <div class="col-md-12">
                <section class="mr-4">
                  <mat-slide-toggle name="barristerPayment" id="barristerPayment" [checked]="barristerPaymentCheck">
                    Reconcile Barrister Payment
                  </mat-slide-toggle>
                </section>
              </div>
            </div>
          </form>
          <div class="row">
            <div class="col-md-12">
              <button type="button" class="btn btn-light" (click)="closeModal()">Close</button>
            </div>
          </div>
      </div>
    </div>
</div>